export const LEAD_TYPES = {
  callback: "Rückruf",
  email: "E-Mail-Anfrage",
  damage: "Schadenmeldung",
};

export const LEAD_STATUS = {
  neu: "Neu",
  in_bearbeitung: "In Bearbeitung",
  erledigt: "Erledigt",
};

export const CAUSES = [
  { value: "unverschuldet", label: "Unverschuldeter Unfall" },
  { value: "teilschuld", label: "Teilschuld" },
  { value: "kasko", label: "Kaskoschaden (Hagel, Wild, selbst verschuldet …)" },
  { value: "unklar", label: "Noch unklar" },
];

export const CALLBACK_TIMES = [
  { value: "sofort", label: "Sofort" },
  { value: "heute", label: "Heute" },
  { value: "termin", label: "Termin" },
];

export const CONCERNS = [
  "Unfallgutachten",
  "Haftpflichtschaden",
  "Kaskoschaden",
  "Leasingrücknahme",
  "Wertgutachten",
  "Oldtimergutachten",
  "Gebrauchtwagen-Check",
  "Sonstiges",
];

export const causeLabel = (v) => CAUSES.find((c) => c.value === v)?.label || v;
export const callbackLabel = (v) => CALLBACK_TIMES.find((c) => c.value === v)?.label || v;
